import { createSelector, Selector } from 'reselect';
import { getCstbState, State } from '../../reducers';
import { ComEthReport } from '../../../api/cstb/comEth/comEthReport/ComEthReport';
import { Maybe } from '../../../utils/Maybe';

export const selectComEthReport: Selector<State, Maybe<ComEthReport>> = createSelector(
  [getCstbState],
  (cstbState) => cstbState?.report
);
